var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegistrationComplete = function SvgRegistrationComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.367 259.089"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 9721"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 9718",
    transform: "translate(-14529.142 -1132.275)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3809",
    d: "M14738.942 1335.996a141.234 141.234 0 0 1-17.745 35.4c-.174.253-.351.5-.528.754l-23.541-7.213c.1-.243.213-.516.332-.814 7.1-17.564 49.8-124.615 44.733-146.712.481 1.809 16.142 61.809-3.251 118.585Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3810",
    d: "M14725.738 1372.786c-.283.22-.574.438-.868.65l-17.659-5.411c.207-.2.448-.431.725-.693 4.531-4.372 17.99-17.468 31.006-31.332 13.988-14.9 27.468-30.681 28.821-37.473-.25 1.544-8.169 48.669-42.025 74.259Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14727.918 1211.234h-1.288v-35.277a20.417 20.417 0 0 0-20.417-20.417h-74.741a20.417 20.417 0 0 0-20.417 20.417v193.535a20.417 20.417 0 0 0 20.417 20.417h74.74a20.417 20.417 0 0 0 20.417-20.417v-133.147h1.288Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14707.035 1160.85h-9.756a7.244 7.244 0 0 1-6.707 9.981h-42.819a7.244 7.244 0 0 1-6.707-9.98h-9.114a15.248 15.248 0 0 0-15.248 15.248v193.251a15.248 15.248 0 0 0 15.248 15.248h75.1a15.248 15.248 0 0 0 15.248-15.248v-193.252a15.248 15.248 0 0 0-15.248-15.248Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.373,
    cy: 8.373,
    r: 8.373,
    transform: "rotate(-80.783 8132.713 -7932.361)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M14623.19 1261.96h92.583v18.279h-92.583z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14625.164 1278.266h88.636v-14.331h-88.636Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14632.923 1265.521a5.46 5.46 0 1 1-5.46 5.46 5.46 5.46 0 0 1 5.46-5.46Z",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M14645.98 1268.845h53.888v1.187h-53.888zM14645.98 1271.931h53.888v1.187h-53.888z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14623.19 1288.045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M0 0h92.583v18.279H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.974 16.306H90.61V1.975H1.974Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46,
    cy: 5.46,
    r: 5.46,
    transform: "translate(4.273 3.561)",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M22.79 6.885h53.888v1.187H22.79zM22.79 9.971h53.888v1.187H22.79z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14623.19 1314.13)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M0 0h92.583v18.279H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.974 16.306H90.61V1.975H1.974Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.46,
    cy: 5.46,
    r: 5.46,
    transform: "translate(4.273 3.561)",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M22.79 6.885h53.888v1.187H22.79zM22.79 9.971h53.888v1.187H22.79z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 443",
    cx: 25.763,
    cy: 25.763,
    r: 25.763,
    transform: "translate(14643.72 1192.225)",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3811",
    d: "M14682.043 1209.807v16.356a1.168 1.168 0 0 1-1.168 1.168h-22.783a1.168 1.168 0 0 1-1.168-1.168v-16.356a1.092 1.092 0 0 1 .07-.391 1.156 1.156 0 0 1 .926-.762 1.108 1.108 0 0 1 .172-.015h22.782a1.107 1.107 0 0 1 .172.015 1.156 1.156 0 0 1 .926.762 1.093 1.093 0 0 1 .071.391Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3812",
    d: "m14681.973 1209.419-12.142 9.037a.575.575 0 0 1-.7 0l-12.142-9.037a1.156 1.156 0 0 1 .926-.762l11.563 8.6 11.563-8.6a1.156 1.156 0 0 1 .932.762Z",
    fill: "var(--primary)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 9720"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3793",
    d: "M75.683 84.359a15.626 15.626 0 0 1-3.874-.5l-.249-.069-.231-.116a64.173 64.173 0 0 1-20.971-16.462 62.319 62.319 0 0 1-10.588-18.8 72.366 72.366 0 0 1-4.092-25.493c0-.182.007-.323.007-.419a10.038 10.038 0 0 1 5.963-9.426C44.42 11.919 69.591 1.58 71.41.833A9.665 9.665 0 0 1 79.074.8c1.312.536 24.58 10.053 29.609 12.448 5.182 2.468 6.565 6.9 6.565 9.131a74.363 74.363 0 0 1-5.2 28.049 64.948 64.948 0 0 1-11.672 18.81C88.848 79.96 79.317 83.762 79.225 83.795a10.414 10.414 0 0 1-3.542.564Zm-2.241-5.552a8.291 8.291 0 0 0 3.969.011c1.575-.574 9.552-4.711 17.006-13.1 10.3-11.59 15.525-26.16 15.533-43.3-.018-.347-.265-2.825-3.546-4.387-4.931-2.348-29.117-12.238-29.361-12.337l-.067-.028a4.382 4.382 0 0 0-3.232-.077l-.223.1c-.27.111-26.989 11.085-29.838 12.272a4.755 4.755 0 0 0-2.7 4.537c0 .12 0 .3-.008.522-.231 11.73 2.484 40.596 32.466 55.787Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3794",
    d: "M72.515 3.238S45.553 14.312 42.664 15.515a7.358 7.358 0 0 0-4.333 6.981c0 2.889-2.167 40.583 34.184 58.809a11.217 11.217 0 0 0 5.8 0c2.5-.913 34.28-16.32 34.28-58.929 0 0 0-4.333-5.055-6.74s-29.5-12.4-29.5-12.4-2.997-1.322-5.525.002Z",
    fill: "var(--primary)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3795",
    d: "M75.404 11.904v59.074s-27.2-13.094-26.962-47.519Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3796",
    d: "M72.581 54.362 63.916 43.22l5.039-3.919 4.1 5.275 13.861-14.632 4.635 4.392Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 9719",
    transform: "translate(-14551.968 -1077.511)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3798",
    d: "M14766.229 1330.962h5.125l2.438-19.769h-7.563Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3799",
    d: "M14764.925 1329.289h10.094a6.433 6.433 0 0 1 6.432 6.432v.209h-16.525Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3800",
    d: "M14783.462 1330.962h5.125l2.438-19.769h-7.563Z",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3801",
    d: "M14782.159 1329.289h10.094a6.433 6.433 0 0 1 6.432 6.432v.209h-16.525Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3802",
    d: "m14774.289 1261.539 1.229 62.717-9.945-.617-6.896-39.947-2.179-27.237Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3803",
    d: "m14791.358 1251.007 1.394 74.242-11.6-.331-2.505-44.132-4.358-15.979-17.795-8.353 2.905-19.974 26.147-.363Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 442",
    cx: 8.894,
    cy: 8.894,
    r: 8.894,
    transform: "translate(14762.466 1166.761)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3804",
    d: "m14778.736 1188.296 1.362 2.064 3.632 10.168-2.905 39.584-17.069.364-2.179-45.395 4.564-5.705Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3805",
    d: "m14754.679 1196.17-2.905-.363s-.726.363-1.089 2.905-4.721 25.058-4.721 25.058l5.81 27.6 6.537-8.716-3.995-15.25 3.995-15.253Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3806",
    d: "M14791.72 1195.804h2.178l5.447 29.415-5.083 22.885-5.084-8.352 1.453-9.079-.726-7.989-2.542-4.721Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3807",
    d: "m14776.616 1175.656-1.617-.4s-1.213-6.873-4.043-6.064-10.107 1.617-10.107-1.617 6.873-6.064 10.915-5.66 9.206 1.745 10.511 7.681c2.092 9.515-4.317 11.919-4.317 11.919l.107-.346a5.4 5.4 0 0 0-1.449-5.513Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3808",
    d: "m14752.136 1195.808 11.621-4.721 2.724-2 8.171 36.134 3.813-37.224 15.071 7.808-5.084 24.695-.726 9.442 2.179 7.626s7.626 5.447 5.084 11.258-5.447 6.174-5.447 6.174-12.347-11.621-13.074-14.526-1.816-7.989-1.816-7.989-6.174 23.242-13.437 22.879-7.263-7.99-7.263-7.99l1.816-7.989 2.905-8.353-1.453-13.8Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3114",
    d: "M242.516 258.945v-24.232s9.444 17.18 0 24.232Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3115",
    d: "m243.1 258.942-17.851-16.388s19.042 4.657 17.851 16.388Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3139",
    d: "M35.663 258.945v-24.232s-9.444 17.18 0 24.232Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3138",
    d: "m35.078 258.941 17.851-16.387s-19.042 4.657-17.851 16.387Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 3131",
    d: "M278.032 259.089H.332a.335.335 0 0 1 0-.67h277.7a.335.335 0 0 1 0 .67Z",
    fill: "#cbcbcb"
  }))));
};
export default SvgRegistrationComplete;